/** Scroll a page section into view inside the locked app shell and pulse-highlight it. */
export function scrollToPageSection(
  sectionId: string,
  pulseClass = "so-section--pulse",
): void {
  const target = document.getElementById(sectionId);
  if (target === null) return;

  target.scrollIntoView({ behavior: "smooth", block: "start" });
  target.classList.add(pulseClass);
  window.setTimeout(() => {
    target.classList.remove(pulseClass);
  }, 1200);
}

export function getAppScrollRoot(): HTMLElement | null {
  // On shell v3 stage routes the template primitive owns scrolling (.wb__body); the legacy
  // routes still scroll .appshell__content itself.
  return document.querySelector(".wb__body") ?? document.querySelector(".appshell__content");
}
